/**
 * @generated SignedSource<<a35b0a16ff5234ea740afc36976bd645>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompanyProfileMainContentV2_organization$data = {
  readonly id: string;
  readonly userLists: {
    readonly count: number;
  };
  readonly visitorIsMember: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyLists_organization" | "CompanyOpenOpportunityListV2_organization" | "CompanyOverviewTab_organization" | "CompanyPeopleList_organization" | "CompanyRecommendationsList_organization">;
  readonly " $fragmentType": "CompanyProfileMainContentV2_organization";
};
export type CompanyProfileMainContentV2_organization$key = {
  readonly " $data"?: CompanyProfileMainContentV2_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompanyProfileMainContentV2_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompanyProfileMainContentV2_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorIsMember",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserListConnection",
      "kind": "LinkedField",
      "name": "userLists",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompanyOpenOpportunityListV2_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompanyRecommendationsList_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompanyPeopleList_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompanyOverviewTab_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CompanyLists_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "4ea4da118457023c39f9e5837a7b3f4c";

export default node;
